module.exports = __webpack_public_path__ + "img/image-solid.5ee5e02c.svg";